module.exports = __webpack_public_path__ + "static/fron-end-4409c64265852849781f1ccd2a11714c.svg";